/* global groots */

( function( global ) { // eslint-disable-line
    var pluginName = 'grInputNumber';

    var config = {}

    if (Array.prototype.contains === undefined) {
        // attach the .contains method to Array's prototype to call it on any array
        Array.prototype.contains = function (thing) {
            if (!this) return false; // if the other array is a falsy value, return false
            var result = false; // start by assuming the array doesn't contain the thing
            for (var i = 0, l=this.length; i < l; i++) {
                if (this[i] instanceof Array) { // if anything in the array is the thing then change our mind from before
                    if (this[i].equals(thing)) result = true;
                } else if (this[i]===thing) result = true;
            }
            return result; //return the decision
        }
    }

    // Constructor
    function grInputNumber( selector, options ) {
        // Merge defaults with user's settings
        this.config = global.methods.objectAssign(config, options);

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        this.min = 0;
        this.max = 0;

        this.wrapper = document.createElement('div');
        this.qtyWrapper = document.createElement('div');
        this.qtyUp = document.createElement('div');
        this.qtyDown = document.createElement('div');

        this.init();
    }

    grInputNumber.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            // ready
            this.ready = true;
            global.methods.toggleAttributeValue(this.selector, 'gr-input-number', 'ready');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): ready');

            // process
            global.methods.toggleAttributeValue(this.selector, 'gr-input-number', 'processing');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): processing');
            this.build();
            this.getAttributes();

            // binding
            var arr = [
                'handleClick'
            ];

            for (var i = 0, len = arr.length; i < len; i++) {
                var method = arr[i];
                this[method] = this[method].bind(this);
            }

            // addEventListener
            this.qtyWrapper.addEventListener('click', this.handleClick);

            // stop process
            global.methods.removeAttributeValue(this.selector, 'gr-input-number', 'processing');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): end processing');
        }
    };

    // Destroy - remove listeners to prevent from memory leak
    // TODO: Remove added nodes
    grInputNumber.prototype.destroy = function destroy() {
        if (groots.verbose) console.log(pluginName + ': destroyed');
        global.methods.removeAttributeValue(this.selector, 'gr-input-number', 'ready');

        // removeEventListener
        this.qtyWrapper.removeListener('click', this.handleClick);
    };

    grInputNumber.prototype.getAttributes = function getAttributes() {
        this.min = this.selector.getAttribute('min');
        this.max = this.selector.getAttribute('max');
    };

    grInputNumber.prototype.build = function build() {
        if (groots.verbose) console.log(pluginName + ' build');

        // build wrapper
        var selector = [this.selector];
        this.wrapper.className = 'gr-quantity-wrapper';
        global.methods.wrapAll(selector, this.wrapper);

        // build qty wrapper
        this.qtyWrapper.className = 'gr-quantity';
        this.wrapper.appendChild(this.qtyWrapper);

        // build up
        this.qtyUp.className = 'gr-quantity__up';
        this.qtyUp.setAttribute('gr-input-number-increment', '');
        this.qtyWrapper.appendChild(this.qtyUp);

        // build down
        this.qtyDown.className = 'gr-quantity__down';
        this.qtyDown.setAttribute('gr-input-number-decrement', '');
        this.qtyWrapper.appendChild(this.qtyDown);
    };

    grInputNumber.prototype.handleClick = function handleClick(event) {
        if (groots.verbose) console.log(pluginName + ' click');

        if (event.target.hasAttribute('gr-input-number-increment')) {
            this.increment();
        } else if (event.target.hasAttribute('gr-input-number-decrement')) {
            this.decrement();
        }

        if (this.config.trigger) {
            clearTimeout(this.triggerTimeout);
            var me = this;
            this.triggerTimeout = setTimeout(function() {
                if (window.jQuery) {
                    $(me.selector).trigger('change');
                } else {
                    // Pure js way ??
                }
            }, 710);
        }
    };

    grInputNumber.prototype.increment = function increment() {
        if (groots.verbose) console.log(pluginName + ' increment');

        var value = this.selector.value;
        value++;

        if (!this.max || value <= this.max) {
            this.selector.value = value++;
        }
    };

    grInputNumber.prototype.decrement = function decrement() {
        if (groots.verbose) console.log(pluginName + ' decrement');

        var value = this.selector.value;
        value--;

        if (!this.min || value >= this.min) {
            this.selector.value = value;
        }
    };

    // jQuery wrapper, if available
    if (window.jQuery) {
        $.fn[pluginName] = function (options) {
            options = options || config;
            return this.each(function() {
                // add plugin to element data
                if (!$.data(this, pluginName) ) $.data(this, pluginName, new grInputNumber(this, options));
            });
        };
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grInputNumber;
    // Export to Browser
    else global[pluginName] = grInputNumber; // eslint-disable-line

    // app instantiation
    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        if ($container.find('[gr-form] input[type="number"]').length) {
            window.groots.grInputNumber = { instances: {} };
            var all = $container.find('[gr-form] input[type="number"]');
            var index = -1;
            while (all[++index])
                global.grInputNumber.instances[index] = new grInputNumber(all[index], {trigger:true});
        }
    });

}( window.groots ));
